module.exports = __webpack_public_path__ + "img/ckgdc.86f72e1d.png";